export default "__VITE_ASSET__rUF5CQwA__"